define("shared/components/shared/ui/notification-banner", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{concat "cPM--modalBanner--" @status}}>
    <div class="u--row">
      <div class="u--col__9">
        {{! Title }}
        <p class="cPM--modalBanner__title">
          {{@title}}
        </p>
        {{! Text }}
        <p class="cPM--modalBanner__desc">
          {{@description}}
        </p>
      </div>
      <div class="u--col__3">
        {{#if @onClick}}
          {{#if (eq @status "error")}}
            <Shared::Ui::Button
              class={{"u--float--right u--m__t__sm u--text--danger"}}
              @onClick={{@onClick}}
              @text={{@buttonText}}
              @type="outline"
            />
          {{else if (eq @status "warning")}}
            <Shared::Ui::Button
              class={{"u--float--right u--m__t__sm u--text--warning"}}
              @onClick={{@onClick}}
              @text={{@buttonText}}
              @type="outline"
            />
          {{/if}}
        {{/if}}
      </div>
    </div>
  </div>
  */
  {
    "id": "TfdE11Hw",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"cPM--modalBanner--\",[30,1]],null]],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"cPM--modalBanner__title\"],[12],[1,\"\\n        \"],[1,[30,2]],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"cPM--modalBanner__desc\"],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__3\"],[12],[1,\"\\n\"],[41,[30,4],[[[41,[28,[37,2],[[30,1],\"error\"],null],[[[1,\"          \"],[8,[39,3],[[24,0,\"u--float--right u--m__t__sm u--text--danger\"]],[[\"@onClick\",\"@text\",\"@type\"],[[30,4],[30,5],\"outline\"]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,2],[[30,1],\"warning\"],null],[[[1,\"          \"],[8,[39,3],[[24,0,\"u--float--right u--m__t__sm u--text--warning\"]],[[\"@onClick\",\"@text\",\"@type\"],[[30,4],[30,5],\"outline\"]],null],[1,\"\\n        \"]],[]],null]],[]]]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@status\",\"@title\",\"@description\",\"@onClick\",\"@buttonText\"],false,[\"concat\",\"if\",\"eq\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/ui/notification-banner.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});